import { SelectOption } from "../../../globals/interfaces";

export const DISPLAY_COMPONENTS: Record<string, { name: string }> = {
    queue: {
        name: 'Queue'
    },
    dock: {
        name: 'Dock'
    },
    media: {
        name: 'Media Carousel'
    },
    deviceStatus: {
        name: 'Device Status'
    },
    tempControl: {
        name: 'Temp. Control'
    },
    badgeExpiration: {
        name: 'Badge Expiration Monitoring'
    },
    breakdownReport: {
        name: 'Breakdown Report'
    },
    officeLobby: {
        name: 'Office Lobby'
    },
    dockLobby: {
        name: 'Dock Lobby'
    },
    ballMat: {
        name: 'Ball Mat Inventory'
    },
    uldBreakdownPerf: {
        name: 'ULD Breakdown Performance'
    },
    transferLane: {
        name: 'Transfer Lane'
    },
    multiDisplay: {
        name: 'Multi Display'
    },
    officeProductivity: {
        name: 'Office Productivity',
    }
    //   dashboard: DashboardDisplay,
    //   analytics: AnalyticsDisplay,
    //   monitoring: MonitoringDisplay,
    //   reports: ReportsDisplay,
} as const;

export const DISPLAY_OPTIONS: Array<SelectOption> = Object.keys(DISPLAY_COMPONENTS).map(key => ({
    label: DISPLAY_COMPONENTS[key].name,
    value: key
}));